import { j as o } from "../../../jsx-runtime-B6kdoens.js";
import { a as s } from "../../../index-CROKJrb5.js";
import { c as m, f as p } from "../../../create-component-CBAeEoQ6.js";
import { Typography as c } from "../../Typography/index.js";
const n = m(
  "CardMeta",
  p(
    ({ children: r, className: t, ...a }, e) => /* @__PURE__ */ o.jsx(
      c,
      {
        ref: e,
        size: "meta",
        className: s("cur-flex cur-gap-2 cur-text-subtle", t),
        ...a,
        children: r
      }
    )
  )
);
export {
  n as CardMeta
};
//# sourceMappingURL=index.js.map
